import { render, staticRenderFns } from "./PostProduct.vue?vue&type=template&id=ba864198&scoped=true&"
import script from "./PostProduct.vue?vue&type=script&lang=js&"
export * from "./PostProduct.vue?vue&type=script&lang=js&"
import style0 from "./PostProduct.vue?vue&type=style&index=0&id=ba864198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba864198",
  null
  
)

export default component.exports